import { CreateTableOutput } from 'aws-sdk/clients/dynamodb';
import { AWSError } from 'aws-sdk/lib/error';
import { PromiseResult } from 'aws-sdk/lib/request';

import { MonitorChecksDatasource } from '../monitoring/checks/service';
import { CONNECTION_TABLE_SCHEMA } from '../monitoring/connect/schema';
import { MONITORING_TABLE_SCHEMA } from '../monitoring/db/schema';
import { DynamoDBClient, PostgresClient } from '../shared';
import { DEFAULT_DYNAMO_DB_CLIENT } from '../shared/aws/dynamodb';
import { DEFAULT_POSTGRES_CLIENT } from '../shared/postgres';
import { STATUS_PAGE_TABLE_SCHEMA } from '../status-pages/db/schema';

async function initializeDynamoDBTables(
  dynamoClient: DynamoDBClient
): Promise<PromiseResult<CreateTableOutput, AWSError>[]> {
  const dynamoSchemas = [
    MONITORING_TABLE_SCHEMA,
    CONNECTION_TABLE_SCHEMA,
    STATUS_PAGE_TABLE_SCHEMA,
  ];

  return await Promise.all(dynamoSchemas.map(dynamoClient.createTable));
}

async function initiliazeTimescaleDBTables(postgresClient: PostgresClient): Promise<void> {
  const monitorChecksDatasource = new MonitorChecksDatasource(postgresClient);
  await monitorChecksDatasource.createChecksSchema();
  await monitorChecksDatasource.getLatency().createTable();
}

export async function initializeTables(
  dynamoClient: DynamoDBClient = DEFAULT_DYNAMO_DB_CLIENT,
  postgresClient: PostgresClient = DEFAULT_POSTGRES_CLIENT
): Promise<void> {
  await initializeDynamoDBTables(dynamoClient);
  await initiliazeTimescaleDBTables(postgresClient);
}
